export default function filterImageUrlExtension(imageURL) {
    return imageURL && typeof imageURL === 'string'
        ? imageURL.trim().replace(/(.jpg|.tif|.png|.gif|.jpeg)$/gi, '')
        : '';
}
